"use strict";
/**
 * Review Database Record Types
 *
 * Based on actual backend implementation analysis
 * Source: pattern-reviews.ts, review-flagging.ts, get-pattern-reviews.ts
 */
Object.defineProperty(exports, "__esModule", { value: true });
